/* AM-BUNDLE — logica del widget de packs de ALTO MATÉ.
   Datos por DOM (data-am-variants / data-am-optnames). Cero dependencias.

   CONTROLES: todas las opciones se eligen con <select>, igual que Kaching.
   Tampoco hay boton "poner los N iguales al primero": lo saco Rome.

   Defectos corregidos tras auditoria (ver comentarios P0-x):
   P0-1 los packs no tocados mostraban precios de la eleccion vieja
   P0-2 un toque que no cambiaba nada desconectaba el pack de la herencia
   P0-3 cambiar de capacidad borraba el color y no lo devolvia
   P0-6 doble alta al carrito por doble toque
   P0-7 se ignoraba el ?variant= con el que llegan los ads
   P0-8 volver del checkout con Atras dejaba el widget congelado
   P0-9 con teclado solo se podia elegir el pack que ya estaba elegido
   P0-10 un 422 con recorte de stock dejaba el carrito cambiado sin avisar
   P0-11 los colores agotados no aparecian y se perdia la escasez real
   P0-12 un ad a un color agotado perdia tambien el color, no solo la capacidad

  P0-11: LOS COLORES SIN STOCK SE MUESTRAN, PERO NO SE PUEDEN ELEGIR.
  El widget filtraba por disponibilidad y de los 14 colores del Acero
  mostraba 8. Los 6 agotados son prueba de escasez real y el dueño los
  quiere a la vista: ver que faltan colores es lo que apura a comprar el
  que queda. Kaching hace exactamente esto en la tienda publicada — lista
  los 14 y les agrega " - no disponible" —, asi que ademas es paridad.
  La diferencia con Kaching: ahi los agotados se pueden tocar; aca van con
  el atributo disabled, o sea se ven grisados y el navegador no deja
  elegirlos. Pedido explicito de Rome: que se vean pero que no se puedan
  comprar.
  Lo que se ELIGE y lo que se COMPRA sigue saliendo de LIVE (las
  disponibles): valuesFor() no cambio. valuesForAll() es solo para pintar.
*/
(function(){
  var root = document.querySelector('[data-am-bundle]');
  if(!root || root.dataset.amReady) return;
  root.dataset.amReady = '1';

  var VARIANTS  = JSON.parse(root.querySelector('[data-am-variants]').textContent);
  var OPT_NAMES = JSON.parse(root.querySelector('[data-am-optnames]').textContent);
  var D3        = parseInt(root.dataset.discount3, 10);
  var D4        = parseInt(root.dataset.discount4, 10);

  var LIVE = VARIANTS.filter(function(v){ return v.available; });
  if(!LIVE.length){ root.hidden = true; return; }

  var CHEAPEST = LIVE.reduce(function(a,b){ return b.price < a.price ? b : a; });
  var SEP = String.fromCharCode(1); // U+0001: separador interno. Escrito asi para no dejar un byte de control crudo en el asset (rompia el minificador de Shopify).

  /* PRECARGA DE LAS FOTOS DE CADA COLOR (pedido de Rome).
     La miniatura se cambia con thumb.src y la primera vez que se elige un
     color la foto no esta en cache: el navegador la pide recien ahi y la
     caja queda vacia. En 4G eso es medio segundo por cada color probado, y
     el cliente prueba varios antes de decidir. Precargarlas hace que el
     cambio se vea instantaneo.
     Se hace en idle y solo con las DISPONIBLES: las agotadas no se pueden
     elegir, asi que bajarlas seria gastar datos del cliente al pedo. Se
     escalonan de a una para no pelear ancho de banda con la foto principal
     del producto ni con el resto de la pagina. */
  (function precargarFotos(){
    var urls = [], vistas = {}, i;
    for(i=0;i<LIVE.length;i++){
      var u = LIVE[i].img;
      if(u && !vistas[u]){ vistas[u] = 1; urls.push(u); }
    }
    if(!urls.length) return;
    var n = 0;
    function siguiente(){
      if(n >= urls.length) return;
      var img = new Image();
      img.onload = img.onerror = siguiente;
      img.src = urls[n++];
    }
    if(window.requestIdleCallback) requestIdleCallback(siguiente, {timeout:2500});
    else setTimeout(siguiente, 1200);
  })();

  // P0-7: LA SEMILLA SALE DE LA URL SI EL VISITANTE VINO POR UN AD.
  //
  // Casi todo el trafico entra desde Meta, y varios anuncios apuntan a un
  // color puntual con ?variant=. El widget arrancaba siempre en la variante
  // mas barata: el cliente hacia clic en el mate 750ml y el widget le
  // armaba un 500ml — otro producto y $5.000 menos de lo que vio en el ad.
  // Kaching SI lo respeta, asi que ignorarlo no era paridad: era regresion.
  //
  // P0-12: EL ?variant= SE BUSCA EN VARIANTS (TODAS) Y NO EN LIVE, A PROPOSITO.
  //
  // Buscar solo entre las disponibles parecia lo prudente, pero hacia perder
  // el ad entero: hay 15 variantes agotadas, y si el link apuntaba a una de
  // ellas no se encontraba nada y se caia de una en CHEAPEST.options. O sea
  // se tiraba la capacidad Y el color que pidio el anuncio de un saque,
  // aunque el color siguiera existiendo en la otra capacidad. Caso real:
  // 750ml/Violeta esta agotado pero 500ml/Violeta se vende, y el que venia
  // de un ad de Violeta aterrizaba en Blanco — otro producto del que vio, y
  // con el precio del widget peleado con el de arriba de la ficha.
  // Por eso se busca en TODAS: encontrada la variante (aunque este muerta)
  // se sabe QUE pidio el anuncio, y mejorCombinacion() revalida nivel por
  // nivel para conservar lo que todavia se puede comprar. Recien si el color
  // no existe disponible en ninguna capacidad se cae en la mas barata, que
  // es el comportamiento de antes.
  var SEED = (function(){
    try{
      var vid = new URLSearchParams(window.location.search).get('variant');
      if(!vid) return null;
      var v = VARIANTS.find(function(x){ return String(x.id) === String(vid); });
      return v ? mejorCombinacion(v.options) : null;
    }catch(e){ return null; }
  })() || CHEAPEST.options;

  function money(cents){
    return '$' + (cents/100).toLocaleString('es-AR',{
      minimumFractionDigits:0, maximumFractionDigits:0
    });
  }
  function perUnitDiscount(qty){
    if(qty >= 4) return D4;
    if(qty === 3) return D3;
    return 0;
  }

  function installmentsFor(cents){
    if(cents >= 13900000) return 9;
    if(cents >= 7990000) return 6;
    if(cents >= 3995000) return 3;
    return 0;
  }

  // Shopify contesta casi siempre en castellano y su texto es mas preciso
  // que cualquier generico — llega a nombrar la variante exacta.
  function motivo(status, d){
    var t = ((d && (d.description || d.message)) || '') + '';
    if(/cannot find variant|not found/i.test(t)) return 'Esa combinación ya no está disponible. Probá con otro color.';
    if(/sold out|out of stock|unavailable|agotad/i.test(t)) return 'Se agotó alguna de esas opciones. Probá con otro color.';
    if(/you can only add|maximum quantity|in your cart|cantidad máxima/i.test(t)) return 'No queda stock suficiente de alguna de esas opciones.';
    if(t && !/\b(the|your|cart|item|items|quantity|available|add|stock|sold|only|please)\b/i.test(t)) return t;
    if(status === 422) return 'No hay stock suficiente de alguna de esas opciones.';
    return 'No pudimos agregar el pack. Reintentá en un momento.';
  }

  function valuesFor(level, chosen){
    var seen = {}, out = [];
    LIVE.forEach(function(v){
      for(var i=0;i<level;i++){
        if(chosen[i] && v.options[i] !== chosen[i]) return;
      }
      var val = v.options[level];
      if(val && !seen[val]){ seen[val] = 1; out.push(val); }
    });
    return out;
  }

  /* Los valores del nivel SIN filtrar por stock. valuesFor() sigue devolviendo
     solo los comprables — se usa para elegir y para calcular — y esta devuelve
     todos, para poder mostrar los agotados en la lista.
     Decision de Rome: los colores sin stock se muestran igual, porque son
     prueba de escasez real. Es lo que hace Kaching hoy en la tienda: lista los
     14 colores y les agrega " - no disponible" a los 6 que no hay. */
  function valuesForAll(level, chosen){
    var seen = {}, out = [];
    VARIANTS.forEach(function(v){
      for(var i=0;i<level;i++){
        if(chosen[i] && v.options[i] !== chosen[i]) return;
      }
      var val = v.options[level];
      if(val && !seen[val]){ seen[val] = 1; out.push(val); }
    });
    return out;
  }
  function findVariant(chosen){
    return LIVE.find(function(v){
      return chosen.every(function(c,i){ return c && v.options[i] === c; });
    }) || null;
  }

  /* La mejor combinacion COMPRABLE partiendo de la que pidio el ad, aunque
     esa este agotada. Se recorre nivel por nivel y un valor se conserva solo
     si desde ahi todavia se llega a una variante disponible que respete lo
     que el ad pidio en los niveles siguientes; si no, se reemplaza por el
     primero que si llegue. Por eso 750ml/Violeta agotado aterriza en
     500ml/Violeta y no en 750ml/Blanco: el color es lo que el cliente vio en
     la foto del anuncio, la capacidad la cambia solo con tocar el otro
     desplegable. Devuelve null si el valor pedido de algun nivel no existe
     disponible en ninguna combinacion — ahi el que llama cae en la mas
     barata, que es lo unico honesto que queda.
     Es funcion declarada a proposito: SEED la usa mas arriba y necesita el
     hoisting, igual que ya hace con valuesFor(). */
  function mejorCombinacion(pedido){
    function alcanza(fijos, level, val){
      return LIVE.some(function(v){
        var i;
        for(i=0;i<level;i++){ if(v.options[i] !== fijos[i]) return false; }
        if(v.options[level] !== val) return false;
        for(i=level+1;i<OPT_NAMES.length;i++){
          if(pedido[i] && v.options[i] !== pedido[i]) return false;
        }
        return true;
      });
    }
    var elegido = [];
    for(var l=0;l<OPT_NAMES.length;l++){
      var validos = valuesFor(l, elegido), val = null;
      for(var i=0;i<validos.length;i++){
        if(!alcanza(elegido, l, validos[i])) continue;
        if(validos[i] === pedido[l]){ val = validos[i]; break; }
        if(val === null) val = validos[i];
      }
      if(val === null) return null;
      elegido[l] = val;
    }
    return elegido;
  }

  // P0-3: `pref` recuerda lo que el cliente PIDIO en cada nivel, aunque
  // ahora no sea combinable. Violeta solo existe en 500ml: al pasar a
  // 750ml hay que caer en otro color, pero si vuelve a 500ml tiene que
  // recuperar Violeta y no quedarse con el Blanco impuesto.
  function revalidate(chosen, fromLevel, pref){
    for(var l=fromLevel+1;l<OPT_NAMES.length;l++){
      var valid = valuesFor(l, chosen);
      if(pref && pref[l] && valid.indexOf(pref[l]) !== -1){ chosen[l] = pref[l]; continue; }
      if(valid.indexOf(chosen[l]) === -1) chosen[l] = valid[0];
    }
  }

  var state = { qty: 2, slots: {}, prefs: {}, touched: {}, lastChoice: null };

  function ensureSlots(qty){
    if(!state.slots[qty]){
      var seed = state.lastChoice || SEED;
      state.slots[qty] = [];
      for(var i=0;i<qty;i++) state.slots[qty].push(seed.slice());
    }
    return state.slots[qty];
  }
  function ensurePrefs(qty){
    if(!state.prefs[qty]){
      state.prefs[qty] = [];
      for(var i=0;i<qty;i++) state.prefs[qty].push([]);
    }
    return state.prefs[qty];
  }
  function markTouched(qty, chosen){
    state.touched[qty] = true;
    state.lastChoice = chosen.slice();
  }

  // P0-1: paint() pinta el total de LOS CUATRO packs, no solo del elegido.
  function syncUntouched(){
    if(!state.lastChoice) return;
    var seed = state.lastChoice.join(SEP);
    root.querySelectorAll('[data-am-tier]').forEach(function(tier){
      var q = parseInt(tier.dataset.qty, 10);
      if(!q || state.touched[q]) return;
      var list = ensureSlots(q), changed = false;
      for(var i=0;i<q;i++){
        if(list[i].join(SEP) !== seed){ list[i] = state.lastChoice.slice(); changed = true; }
      }
      if(changed){
        delete state.prefs[q];
        Array.prototype.forEach.call(tier.querySelectorAll('[data-am-slot]'),
          function(s){ delete s.dataset.amPainted; });
      }
    });
  }

  function renderSlot(slotEl, qty, idx){
    var chosen = ensureSlots(qty)[idx];
    var pref   = ensurePrefs(qty)[idx];
    var wrap   = slotEl.querySelector('[data-am-selects]');
    wrap.innerHTML = '';

    OPT_NAMES.forEach(function(name, level){
      var opts = valuesFor(level, chosen);
      var todos = valuesForAll(level, chosen);
      if(opts.indexOf(chosen[level]) === -1) chosen[level] = opts[0];

      if(todos.length < 2){
        chosen[level] = opts[0];
        return;
      }

      var sel = document.createElement('select');
      sel.setAttribute('aria-label', name + ' de la unidad ' + (idx+1));
      // el nivel queda escrito en el DOM: am-bundle-cart.js reconstruye la
      // seleccion leyendo estos selects, y guiarse por el orden de aparicion
      // se desfasa apenas un nivel no dibuje su desplegable
      sel.dataset.level = level;
      todos.forEach(function(val){
        var hay = opts.indexOf(val) !== -1;
        var o = document.createElement('option');
        o.value = val;
        o.textContent = hay ? val : val + ' - no disponible';
        o.disabled = !hay;
        if(val === chosen[level]) o.selected = true;
        sel.appendChild(o);
      });
      sel.addEventListener('change', function(){
        if(chosen[level] === sel.value) return;   // P0-2: no-op
        var etiqueta = sel.getAttribute('aria-label');
        chosen[level] = sel.value; pref[level] = sel.value;
        revalidate(chosen, level, pref);
        markTouched(qty, chosen);
        renderSlot(slotEl, qty, idx);
        paint();
        // renderSlot vacia el contenedor, asi que el <select> que el
        // cliente acaba de usar deja de existir y el foco se cae al
        // <body>: con teclado, cada cambio de color expulsaba del widget.
        var vuelto = slotEl.querySelector('[data-am-selects] [aria-label="' + etiqueta + '"]');
        if(vuelto && document.activeElement === document.body){
          try{ vuelto.focus({preventScroll:true}); }catch(e){ vuelto.focus(); }
        }
      });
      wrap.appendChild(sel);
    });

    var v = findVariant(chosen);
    var thumb = slotEl.querySelector('[data-am-thumb]');
    if(v && v.img){
      thumb.onerror = function(){ thumb.hidden = true; };
      thumb.src = v.img;
      thumb.hidden = false;
    } else {
      thumb.hidden = true;
    }
  }

  function tierTotal(qty){
    var list = ensureSlots(qty), full = 0;
    for(var i=0;i<qty;i++){
      var v = findVariant(list[i]);
      full += v ? v.price : CHEAPEST.price;
    }
    var disc = perUnitDiscount(qty) * qty;
    return { full: full, final: Math.max(0, full - disc), disc: disc };
  }

  function paint(){
    syncUntouched();   // P0-1: antes de calcular nada

    root.querySelectorAll('[data-am-tier]').forEach(function(tier){
      var qty = parseInt(tier.dataset.qty, 10);
      var t = tierTotal(qty);
      var selected = qty === state.qty;

      tier.classList.toggle('is-selected', selected);
      tier.setAttribute('aria-checked', selected ? 'true' : 'false');
      tier.setAttribute('tabindex', selected ? '0' : '-1');

      tier.querySelector('[data-am-total]').textContent = money(t.final);
      tier.querySelector('[data-am-compare]').textContent = t.disc > 0 ? money(t.full) : '';

      var slotsBox = tier.querySelector('[data-am-slots]');
      slotsBox.hidden = !selected;
      if(selected){
        Array.prototype.forEach.call(tier.querySelectorAll('[data-am-slot]'), function(slotEl, idx){
          if(!slotEl.dataset.amPainted){
            renderSlot(slotEl, qty, idx);
            slotEl.dataset.amPainted = '1';
          }
        });
      }
    });

    var cur = tierTotal(state.qty);
    root.querySelector('[data-am-cta-text]').textContent =
      'Agregar al carrito • ' + money(cur.final);

    // "Comprar ahora" NO se esconde en ningun tramo: va siempre, como en
    // Glow Up Era.

    // La cuota se TRUNCA a pesos enteros, no se redondea: el carrito hace
    // lo mismo (Liquid divided_by es entero) y con el redondeo el widget
    // decia $13.317 y el carrito $13.316 para el mismo pack.

    /* El importe se muestra siempre que el tramo tenga cuotas habilitadas.
       Es la cuota del subtotal de productos que el cliente ve en el widget;
       el envio, cuando corresponde, se informa aparte en el checkout. */
    var installmentsLine = root.querySelector('[data-am-installments]');
    var cuotas = installmentsFor(cur.final);
    if(!cuotas){
      installmentsLine.textContent = '';
      installmentsLine.hidden = true;
    }else{
      installmentsLine.hidden = false;
      installmentsLine.innerHTML = cuotas + ' cuotas sin interés de <strong>' +
        money(Math.floor(cur.final / cuotas / 100) * 100) + '</strong>';
    }
  }

  var busy = false;

  // P0-9: EL TECLADO PUEDE RECORRER LOS CUATRO PACKS.
  //
  // El bloque es un role="radiogroup" con roving tabindex: solo el elegido
  // es alcanzable con Tab, y a los otros se llega con las flechas. Estaba
  // implementada la mitad — el tabindex — pero no habia manejo de flechas
  // en ningun lado, asi que Tab entraba al pack elegido y de ahi no se
  // salia: Espacio y Enter re-elegian el mismo. Quien navega con teclado
  // solo podia comprar el pack de 2.
  var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-am-tier]'));

  function elegir(qty, mover){
    if(busy) return;
    state.qty = qty;
    hideError();
    paint();
    if(mover){
      var t = root.querySelector('[data-am-tier][data-qty="' + qty + '"]');
      if(t){ try{ t.focus({preventScroll:true}); }catch(e){ t.focus(); } }
    }
  }

  tiers.forEach(function(tier, idx){
    var qty = parseInt(tier.dataset.qty, 10);

    tier.addEventListener('click', function(ev){
      if(ev.target.closest('select')) return;
      elegir(qty, false);
    });

    tier.addEventListener('keydown', function(ev){
      // dentro de un desplegable las flechas son suyas: cambian la opcion
      if(ev.target.closest('select')) return;

      if(ev.key === ' ' || ev.key === 'Enter'){
        ev.preventDefault(); elegir(qty, true); return;
      }

      var paso = 0;
      if(ev.key === 'ArrowDown' || ev.key === 'ArrowRight') paso = 1;
      else if(ev.key === 'ArrowUp' || ev.key === 'ArrowLeft') paso = -1;
      else if(ev.key === 'Home') paso = -999;
      else if(ev.key === 'End') paso = 999;
      else return;

      ev.preventDefault();
      var i = paso === -999 ? 0
            : paso ===  999 ? tiers.length - 1
            : (idx + paso + tiers.length) % tiers.length;   // da la vuelta
      var destino = parseInt(tiers[i].dataset.qty, 10);
      elegir(destino, true);
    });
  });

  var errBox = root.querySelector('[data-am-error]');
  // Primero se muestra el cartel y despues se escribe: al reves, la
  // mutacion ocurre en un subarbol oculto y los lectores de pantalla no
  // anuncian nada.
  function showError(m){ errBox.hidden = false; errBox.textContent = m; }
  function hideError(){ errBox.hidden = true; }

  function buildItems(){
    var list = ensureSlots(state.qty), byId = {};
    for(var i=0;i<state.qty;i++){
      var v = findVariant(list[i]);
      if(!v) return null;
      byId[v.id] = (byId[v.id] || 0) + 1;
    }
    // Agrupado por variante: 3 iguales van como UNA linea de 3.
    return Object.keys(byId).map(function(id){
      return { id: parseInt(id,10), quantity: byId[id] };
    });
  }

  function addToCart(navigateTo){
    if(busy) return;
    var items = buildItems();
    if(!items){
      showError('Esa combinación no está disponible. Probá con otro color.');
      return;
    }
    var btn = root.querySelector('[data-am-add]');
    var buy = root.querySelector('[data-am-buynow]');
    busy = true;
    btn.disabled = true;
    if(buy) buy.disabled = true;  // P0-6: si no, doble alta al carrito
    root.querySelector('[data-am-cta-text]').textContent = 'Agregando…';
    hideError();

    function restore(){
      busy = false; btn.disabled = false; if(buy) buy.disabled = false;
      paint();   // reescribe el CTA con el total del pack elegido AHORA
    }

    var x = new XMLHttpRequest();
    x.open('POST', '/cart/add.js', true);
    x.timeout = 10000;
    x.setRequestHeader('Content-Type', 'application/json');
    x.setRequestHeader('Accept', 'application/json');
    x.onload = function(){
      if(x.status >= 200 && x.status < 300){
        if(navigateTo){ window.location.href = navigateTo; return; }
        restore();
        document.dispatchEvent(new CustomEvent('am:cart:open'));
        return;
      }
      restore();
      var d = null;
      try { d = JSON.parse(x.responseText); } catch(e){}
      var texto = ((d && (d.description || d.message)) || '') + '';

      // P0-10: UN 422 NO SIEMPRE SIGNIFICA QUE NO SE AGREGO NADA.
      //
      // Medido en la tienda: con 119 unidades en el carrito y un pack de 4,
      // Shopify contesta 422 y IGUAL agrega las 2 que quedaban. El alta
      // multiple es atomica cuando la variante no existe o esta agotada,
      // pero NO cuando lo que falta es disponibilidad: ahi recorta. El caso
      // real no es alguien con 119 unidades: es un color con 3 en stock y
      // un pack de 4.
      // Como el widget solo mostraba el cartel rojo y no tocaba el carrito,
      // el cliente leia "no hay stock" con unidades ya adentro, y si volvia
      // a tocar Agregar recibia otro mensaje distinto ("tu carrito ya tiene
      // la cantidad maxima") sin entender por que.
      //
      // Los dos casos se distinguen por el texto de Shopify: el del recorte
      // trae la cifra ("solo se anadieron N articulos"), el del rechazo
      // total no trae ningun numero. Si hubo recorte se abre el carrito
      // — que se repinta solo — para que el cliente vea lo que realmente
      // quedo, y el aviso se escribe adentro del carrito, porque el cartel
      // del widget queda tapado por el panel.
      //
      // El texto propio reemplaza al de Shopify a proposito: "solo se
      // anadieron 121 articulos al carrito" se lee como que agrego 121,
      // cuando 121 es el total que quedo y lo agregado fueron 2.
      // el numero tiene que venir pegado a una palabra de cantidad: los nombres de variante de esta tienda ("750ml / Violeta") ya traen digitos
      if(x.status === 422 && /\b\d+\s*(art[íi]culos?|unidades?|items?)\b/i.test(texto)){
        var aviso = 'Agregamos solo las unidades que quedaban en stock. Revisá el carrito.';
        document.dispatchEvent(new CustomEvent('am:cart:open'));
        var cajaCarrito = document.querySelector('[data-amc-error]');
        if(cajaCarrito){ cajaCarrito.hidden = false; cajaCarrito.textContent = aviso; }
        else showError(aviso);
        return;
      }

      showError(motivo(x.status, d));
    };
    x.onerror = x.ontimeout = function(){
      restore();
      // /cart/add.js NO es idempotente: si el pedido llego y lo que se
      // perdio fue la respuesta, el pack ya esta en el carrito. Decir
      // "reintenta" es invitar a comprar el doble.
      showError('No pudimos confirmar si se agregó. Revisá tu carrito antes de volver a intentar.');
    };
    x.send(JSON.stringify({ items: items }));
  }

  // P0-8: VOLVER DEL CHECKOUT CON EL BOTON ATRAS.
  //
  // "Comprar ahora" navega al checkout SIN llamar restore() — a proposito:
  // reactivar el boton durante los segundos que tarda en cargar el checkout
  // es justo la ventana donde el cliente vuelve a tocar, y eso reintroduce
  // el doble alta.
  // El precio de eso: iOS Safari y Chrome Android guardan la pagina en
  // bfcache, asi que al volver con Atras el documento vuelve TAL CUAL se
  // fue — con busy en true, los botones deshabilitados y el CTA diciendo
  // "Agregando...". Y como elegir() tambien mira busy, los cuatro packs
  // dejaban de responder: no se podia comprar hasta recargar a mano.
  //
  // Los botones se vuelven a buscar en el DOM en vez de usar una referencia
  // guardada: am-bundle-cart.js reemplaza el de agregar por un clon, y una
  // referencia vieja apunta a un nodo que ya no esta en la pagina.
  function descongelar(){
    busy = false;
    var b = root.querySelector('[data-am-add]');
    var y = root.querySelector('[data-am-buynow]');
    if(b) b.disabled = false;
    if(y) y.disabled = false;
    paint();   // sin esto el boton queda habilitado pero diciendo "Agregando..."
  }
  window.addEventListener('pageshow', function(e){
    if(e.persisted) descongelar();
  });

  root.querySelector('[data-am-add]').addEventListener('click', function(){
    addToCart(null);
  });
  var yaBuy = root.querySelector('[data-am-buynow]');
  if(yaBuy) yaBuy.addEventListener('click', function(){ addToCart('/checkout'); });

  paint();
})();
